<template>
  <a-table :pagination="false" size="small" :columns="columns" row-key="version_id" :data-source="dataSource" bordered>
    <template slot="version" slot-scope="text, record">
      <span>{{ record.version_title }}</span>
    </template>
    <template slot="score" slot-scope="text, record">
      <span>{{ record.score }}分</span>
    </template>
    <template slot="incompleteRequirements" slot-scope="text, record">
      <span v-if="record.incomplete_requirements.length > 0">
        <a v-for="req in record.incomplete_requirements" :key="req.id" class="link" :href="link(req)" target="_blank">{{ `[PR-${req.id}]${req.title}; ` }}</a>
      </span>
      <span v-else>无</span>
    </template>
  </a-table>
</template>

<script>
const columns = [
  {
    title: '迭代',
    scopedSlots: { customRender: 'version' }
  },
  {
    title: '评分',
    align: 'center',
    scopedSlots: { customRender: 'score' }
  },
  {
    title: '未完成需求',
    scopedSlots: { customRender: 'incompleteRequirements' }
  }
];
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns
    };
  },
  computed: {
    link() {
      return req => {
        return this.$router.resolve({
          name: 'page:project:story:detail',
          params: {
            project_id: req.project_id
          },
          query: { storyId: req.id }
        }).href;
      };
    }
  }
};
</script>
<style lang="less" scoped>
.link {
  display: block;
}
</style>
